import { resourceExplorerDataGridViewSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/resourceExplorerDataGridViewSelector";
import { resourceExplorerDataGridDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data-grid/resourceExplorerDataGridDataSelector";
import { resourceExplorerGranularViewGridDataSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/data-grid/granular-costs-view/resourceExplorerGranularViewGridDataSelector";
import { RootState } from "@/store/store";

export const billingExplorerIsCsvLoadingEnabledSelector = (
  state: RootState,
) => {
  const dataGridView = resourceExplorerDataGridViewSelector(state);

  if (dataGridView === "total") {
    const data = resourceExplorerDataGridDataSelector(state);
    return !!data?.length;
  }
  const data = resourceExplorerGranularViewGridDataSelector(state);
  return !!data?.length;
};
